import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    routeType: "",
    editedRoute: {},
    states: [],
  },
  getters: {
    routeType(state) {
      return state.routeType;
    },
    routeStartLastMiles(state) {
      return state.editedRoute.lastmile;
    },
    routeTripBreak(state) {
      return state.editedRoute.trip[0];
    },
    routeTerminal(state) {
      return state.editedRoute.terminal[0];
    },
    routeSchedule(state) {
      return state.editedRoute.schedule;
    },
    states(state) {
      return state.states;
    },
  },
  mutations: {
    SAVE_ROUTE_TYPE(state, payload) {
      state.routeType = payload;
    },
    UPDATE_ROUTE_TERMINAL(state, payload) {
      state.editedRoute.terminal = payload;
    },
    UPDATE_ROUTE_TRIP_BREAK(state, payload) {
      state.editedRoute.trip = payload;
    },
    UPDATE_ROUTE_SCHEDULE(state, payload) {
      state.editedRoute.schedule = payload;
    },
    UPDATE_ROUTE_START_NAME(state, payload) {
      state.editedRoute.name = payload;
    },
    UPDATE_ROUTE_START_LAST_MILES(state, payload) {
      state.editedRoute.lastmile = payload;
    },
    SAVE_STATES(state, payload) {
      state.states = payload;
    },
  },
  actions: {
    saveRouteType({ commit }, payload) {
      commit("SAVE_ROUTE_TYPE", payload);
    },
    updateRouteTerminal({ commit }, payload) {
      commit("UPDATE_ROUTE_TERMINAL", payload);
    },
    saveStates({ commit }, payload) {
      commit("SAVE_STATES", payload);
    },
  },
};
